<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Gordon Wilson is emeritus professor in Environment and Development. He has previously co-authored <em>Learning for Development</em>, <em>The Lived Experience of Climate Change</em> and <em>Environment, Development and Sustainability</em>, as well as invited chapters for nine further books. He has published <em>The Pyrenees: Trekking the Mountains of Hope and Freedom</em>.</p><br/>
<p style="text-indent:0em">Steve Cracknell has written three other books on the Pyrenees. In the first two, the mountains and their inhabitants are seen through the eyes of a long-distance walker. His third work, <em>The Implausible Rewilding of the Pyrenees</em> is based on interviews with shepherds, farmers, environmentalists and hunters, some of whom also feature in <em>Mountain People</em>. The author and environmentalist Dr Mark Avery chose it for his Nature Book of the Year, 2021.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3f95ce3a